import styled from "styled-components";
import fipayFonts from "../../../../theme/index";
import { colors } from "../../../../theme/color";

export const TestimonialLeftContainer = styled.div`
  width: 40%;
  height: 465px;
  flex-shrink: 0;
  margin-left: 30px;

  @media screen and (max-width: 1024px) {
    width: 40%;
    height: 311.09px;
    margin-left: 0;

    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 21px;
    overflow: hidden;
  }
  @media screen and (max-width: 768px) {
    width: 100%;
    height: 271.09px;
    margin-left: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 21px;
  }

  @media screen and (max-width: 375px) {
    width: 327px;
    height: 236px;

    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
  }
  @media screen and (max-width: 320px) {
    width: 327px;
    height: 236px;

    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
  }
`;

export const TextHolder = styled.div`
  gap: 24px;
  @media screen and (max-width: 768px) {
    width: 140px;
    height: 38px;
    padding: 10px;
    border-radius: 30px;
    gap: 10px;
  }

  @media screen and (max-width: 375px) {
    width: 327px;
    height: 236px;
  }
  @media screen and (max-width: 320px) {
    width: 300px;
    height: 236px;
  }
`;

export const TitleText = styled.div`
  text-align: left;
  font-size: ${fipayFonts.fipayFonts.heading1.size};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
  color: ${colors.NAVYBLUE};

  @media screen and (max-width: 1024px) {
    width: 300px;
    font-size: ${fipayFonts.fipayFonts.heading2.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    text-align: left;
    margin-bottom: 20px;
  }
  @media screen and (max-width: 768px) {
    width: 570px;
    margin-bottom: 0px;
    font-size: ${fipayFonts.fipayFonts.heading2.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    text-align: left;
  }

  @media screen and (max-width: 430px) {
    width: 327px;
    height: 64px;
    font-size: ${fipayFonts.fipayFonts.fontSize.heading3};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    line-height: ${fipayFonts.fipayFonts.lineHeight.heading3};
    text-align: left;
  }

  @media screen and (max-width: 375px) {
    width: 327px;
    height: 64px;
    font-size: ${fipayFonts.fipayFonts.fontSize.heading3};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    line-height: ${fipayFonts.fipayFonts.lineHeight.heading3};
    text-align: left;
  }
`;

export const SubtitleText = styled.div`
  width: 485px;
  height: 64px;
  text-align: left;
  font-size: ${fipayFonts.fipayFonts.body1.size};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  line-height: ${fipayFonts.fipayFonts.lineHeight.body1};
  color: ${colors.DARK_GRAY};

  @media screen and (max-width: 1024px) {
    width: 355px;
    height: 48px;
    font-size: ${fipayFonts.fipayFonts.body2.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
    color: ${colors.DARK_GRAY};
    text-align: left;
  }
  @media screen and (max-width: 768px) {
    width: 485px;
    height: 48px;
    font-size: ${fipayFonts.fipayFonts.body2.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
    color: ${colors.DARK_GRAY};
    text-align: left;
  }

  @media screen and (max-width: 430px) {
    width: 320px;
    height: 48px;
    font-size: ${fipayFonts.fipayFonts.body3.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
    color: ${colors.DARK_GRAY};
    text-align: left;
  }

  @media screen and (max-width: 375px) {
    width: 320px;
    height: 48px;
    font-size: ${fipayFonts.fipayFonts.body3.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
    color: ${colors.DARK_GRAY};
    text-align: left;
  }
  @media screen and (max-width: 320px) {
    width: 270px;
    height: 48px;
    font-size: ${fipayFonts.fipayFonts.body3.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
    color: ${colors.DARK_GRAY};
    text-align: left;
  }
`;

export const Picture_group = styled.img`
  width: 334px;
  height: 60px;
  flex-shrink: 0;
  object-fit: cover;
  padding-top: 30px;

  @media screen and (max-width: 768px) {
    width: 328px;
    height: 60px;
    padding-top: 10px;
  }

  @media screen and (max-width: 375px) {
    width: 216px;
    height: 38px;
    padding-top: 10px;
  }
`;
